import { useEffect, useState } from "react";
// import { loadGoogleMaps } from "../utils/loadGoogleMaps";

export function useGoogleMaps() {
  const [loaded, setLoaded] = useState(false);

  // In your useGoogleMaps hook
  const checkGoogleMapsReady = () => {
    return !!(
      window.google?.maps?.importLibrary &&
      typeof window.google.maps.importLibrary === "function"
    );
  };

  // useEffect(() => {
  //   checkGoogleMapsReady();
  //   loadGoogleMaps().then(() => setLoaded(true));
  // }, []);

  useEffect(() => {
    const checkAndLoad = async () => {
      // await loadGoogleMaps();

      // Wait for importLibrary to be available
      const waitForImportLibrary = () => {
        return new Promise((resolve) => {
          const check = () => {
            if (checkGoogleMapsReady()) {
              resolve();
            } else {
              setTimeout(check, 1000);
            }
          };
          check();
        });
      };

      await waitForImportLibrary();
      setLoaded(true);
    };

    checkAndLoad();
  }, []);

  return loaded;
}
